// @mui
import { Container, Grid } from '@mui/material';

// components

import { observer } from 'mobx-react-lite';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Page from 'src/components/Page';
import useLocales from 'src/hooks/useLocales';
import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useStore } from 'src/stores/store';
import CustomerDetailTableRow from '../CustomerList/CustomerDetailTableRow';
import { useState, useEffect } from 'react';
import Loader from 'src/components/loader/Loader';

// ----------------------------------------------------------------------

export default observer(function CustomerDetailHeader() {
  const { translate } = useLocales();
  const {
    CustomerStore: { SelectedCustomerDetail, clearSelectedCustomer, loadCustomerDetail, ID },
    ContractInfoStore,
    RentPaymentStore,
    ElectricityPaymentStore,
  } = useStore();

  const { GetHistory, ContractHistoryResult } = ContractInfoStore;
  const { GetRentPaymentHistory, RentPaymentHistoryResult } = RentPaymentStore;
  const { GetElectricityPaymentHistory, ElectricityPaymentHistoryResult } = ElectricityPaymentStore;

  const [isLoading, setIsLoading] = useState(true); // Loading state

  useEffect(() => {
    if (ID) {
      setIsLoading(true);
      loadCustomerDetail(ID)
        .then(() => {
          GetElectricityPaymentHistory({ customerId: ID });
          GetRentPaymentHistory({ customerId: ID });
          GetHistory({ customerId: ID });
        })
        .finally(() => setIsLoading(false)); // Ensure loading ends
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ID]);

  const { themeStretch } = useSettings();

  // Handle case when no ID or data is available
  if (!ID) {
    return (
      <Page title={translate('Customer.CustomerDetails')}>
        <Container maxWidth={themeStretch ? false : 'lg'}>
          <HeaderBreadcrumbs
            heading={translate('Customer.CustomerDetails')}
            links={[
              { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
              {
                name: `${translate('Customer.CustomerDetails')}`,
                href: PATH_DASHBOARD.Customer.list,
              },
            ]}
          />
          <p>{translate('Customer.NoData')}</p>
        </Container>
      </Page>
    );
  }

  return (
    <Page title={translate('Customer.DetailsTitle')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Customer.CustomerDetails')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },
            { name: `${translate('Customer.Customer')}`, href: PATH_DASHBOARD.Customer.list },
          ]}
        />
        {isLoading ? ( // Show loading state
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <Loader /> {/* Replace with Loader */}
          </Grid>
        ) : SelectedCustomerDetail ? ( // Render details if available
          <Grid container>
            <CustomerDetailTableRow
              row={SelectedCustomerDetail}
              clearCustomer={clearSelectedCustomer}
              electricityRow={ElectricityPaymentHistoryResult}
              rentRow={RentPaymentHistoryResult}
              contractRow={ContractHistoryResult}
            />
          </Grid>
        ) : (
          <Grid container justifyContent="center" alignItems="center" style={{ height: '50vh' }}>
            <p>{translate('Customer.NoDetailsFound')}</p>
          </Grid>
        )}
      </Container>
    </Page>
  );
});
